import script from "./TheRequiredPermission.vue?vue&type=script&setup=true&lang=js"
export * from "./TheRequiredPermission.vue?vue&type=script&setup=true&lang=js"

import "./TheRequiredPermission.vue?vue&type=style&index=0&id=3ff30c8a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ff30c8a"]])

export default __exports__